import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useSelectedPropertyId } from '../../../store/propertyStore'
import { shiftService } from '../services/shiftService'
import { CURRENT_SHIFT_QUERY_KEY, HANDOVER_POLL_MS } from '../constants/handoverConstants'
import type { ShiftResponse } from '../types/shift.types'

export function useCurrentShift(): UseQueryResult<ShiftResponse | null> {
  const propertyId = useSelectedPropertyId()
  return useQuery<ShiftResponse | null>({
    queryKey: [CURRENT_SHIFT_QUERY_KEY, { propertyId }],
    queryFn: () => shiftService.getCurrent(propertyId as number),
    enabled: propertyId !== null,
    refetchInterval: HANDOVER_POLL_MS,
    meta: { silent: true, source: 'useCurrentShift' },
  })
}
